/**
 * Automy.Core.Enums.Reporting.Datasets.ReportingDatasetFieldType
 * JSON `fields[].type` (string token). Semantic catalog type, not a form control.
 */
export default Object.freeze({
  Guid: 'guid',
  Text: 'text',
  Number: 'number',
  Boolean: 'boolean',
  Date: 'date',
  DateTime: 'datetime',
  User: 'user',
  Reference: 'reference',
  Position: 'position',
  Area: 'area',
  UserGroup: 'user-group',
});
